import * as ActionTypes from 'constants';

//Adds job to state.
export const addJob = job => ({
  type : ActionTypes.ADD_JOB,
  payload : { job }
});

//Removes job from state.
export const removeJob = job => ({
  type : ActionTypes.REMOVE_JOB,
  payload : { job }
});

export const updateJob = job => ({
  type : ActionTypes.UPDATE_JOB,
  payload : { job }
});

export const updateJobKeywords = keywords => ({
  type : ActionTypes.UPDATE_JOB_KEYWORDS,
  payload : { keywords }
})

export const startCreatingJob = f => ({
  type : ActionTypes.START_CREATING_JOB
});

export const hideCreateJob = f => ({
  type : ActionTypes.HIDE_CREATE_JOB
})

export const createJob = job => ({
  type : ActionTypes.CREATE_JOB,
  payload : { job }
});

export const toggleShowDeleteJobConfirm = (val) => ({
  type : ActionTypes.SHOW_DELETE_JOB_CONFIRM,
  payload : val
})

export const deleteJob = job => ({
  type : ActionTypes.DELETE_JOB,
  payload : { job : job._id || job }
})

export const previewJob = (job) => ({
  type : ActionTypes.PREVIEW_JOB,
  payload : { id: job._id || job }
});

export const selectJob = (job) => ({
  type : ActionTypes.SELECT_JOB,
  payload : { id : job._id || job }
})

export const deselectJob = (job) => ({
  type : ActionTypes.DESELECT_JOB,
  payload : { id : job._id || job }
});

export const clearJobs = () => ({
  type : ActionTypes.CLEAR_DOWNLOADED_JOBS
})

export const fetchJob = id => ({
  type : ActionTypes.FETCH_JOB,
  payload : { id }
});

export const setCurrentJob = id => ({
  type : ActionTypes.SET_CURRENT_JOB,
  payload : { id }
});

export const fetchJobs = (options = {}) => ({
  type : ActionTypes.FETCH_JOBS,
  payload : { ...options }
})

export const fetchNextJobs = (client, show_closed = true) => ({
  type : ActionTypes.FETCH_NEXT_JOBS,
  payload : {client, show_closed}
})

export const fetchJobsFilters = f => ({
  type : ActionTypes.FETCH_JOBS_FILTERS
})

export const recieveJobs = payload => ({
  type : ActionTypes.FETCH_JOBS_SUCCESS,
  payload
});

export const recieveNextJobs = payload => ({
  type : ActionTypes.FETCH_NEXT_JOBS_SUCCESS,
  payload
});

export const recieveJobsFilters = filters => ({
  type : ActionTypes.FETCH_JOBS_FILTERS_SUCCESS,
  payload : { filters }
})

export const toggleJobsFilter = filter => ({
  type : ActionTypes.TOGGLE_JOBS_FILTER,
  payload : { filter }
})



// WEBPACK FOOTER //
// ./src/common/actions/jobs.js